export const PRICE_FIELDS = [
  { key: "price_bayi", label: "Bayi Fiyatı" },
  { key: "price_nokta", label: "Nokta Fiyatı" },
  { key: "price_nihai_tuketici", label: "Nihai Tüketici Fiyatı" },
  { key: "price_internet", label: "İnternet Fiyatı" },
];

export const CURRENCIES = ["TRY", "EUR", "USD"];

export const ADJUST_REASONS = [
  { key: "sayim_farki", label: "Sayım Farkı" },
  { key: "hasar", label: "Hasar" },
  { key: "kayip", label: "Kayıp" },
  { key: "hatali_giris", label: "Hatalı Giriş" },
  { key: "iade", label: "İade" },
  { key: "diger", label: "Diğer" },
];

export const STOCK_STATUS = {
  ok: { label: "Normal", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  critical: { label: "Kritik Stok", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  out: { label: "Stok Yok", cls: "bg-rose-100 text-rose-800 border-rose-400" },
};

export const EMPTY_PRODUCT = {
  code: "", name: "", description: "", purchase_price: 0, purchase_currency: "TRY",
  price_bayi: 0, price_nokta: 0, price_nihai_tuketici: 0, price_internet: 0, critical_stock: 0, active: true,
};

export const fmtNum = (v, d = 2) => Number(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: d, maximumFractionDigits: d });
export const fmtQty = (v) => Number(v || 0).toLocaleString("tr-TR", { maximumFractionDigits: 3 });

export function toQuery(values) {
  const p = new URLSearchParams();
  Object.entries(values || {}).forEach(([k, v]) => { if (v !== "" && v !== null && v !== undefined && v !== false) p.set(k, v); });
  const s = p.toString();
  return s ? `?${s}` : "";
}
